import { render, staticRenderFns } from "./FolderMultiple.vue?vue&type=template&id=5e5aaef4"
import script from "./FolderMultiple.vue?vue&type=script&lang=js"
export * from "./FolderMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports